import {playerSlice} from './slice';

export * from './slice';
export * from './selectors';
export * from './actions';
export default playerSlice.reducer;
